//#region src/timezone.ts
var Timezone = /* @__PURE__ */ function(Timezone) {
	Timezone["AmericaAdak"] = "America/Adak";
	Timezone["AmericaAnchorage"] = "America/Anchorage";
	Timezone["AmericaBoise"] = "America/Boise";
	Timezone["AmericaChicago"] = "America/Chicago";
	Timezone["AmericaDenver"] = "America/Denver";
	Timezone["AmericaDetroit"] = "America/Detroit";
	Timezone["AmericaIndianaIndianapolis"] = "America/Indiana/Indianapolis";
	Timezone["AmericaIndianaMarengo"] = "America/Indiana/Marengo";
	Timezone["AmericaIndianaKnox"] = "America/Indiana/Knox";
	Timezone["AmericaIndianaPetersburg"] = "America/Indiana/Petersburg";
	Timezone["AmericaIndianaTell_City"] = "America/Indiana/Tell_City";
	Timezone["AmericaIndianaVevay"] = "America/Indiana/Vevay";
	Timezone["AmericaIndianaVincennes"] = "America/Indiana/Vincennes";
	Timezone["AmericaIndianaWinamac"] = "America/Indiana/Winamac";
	Timezone["AmericaKentuckyLouisville"] = "America/Kentucky/Louisville";
	Timezone["AmericaKentuckyMonticello"] = "America/Kentucky/Monticello";
	Timezone["AmericaJuneau"] = "America/Juneau";
	Timezone["AmericaLosAngeles"] = "America/Los_Angeles";
	Timezone["AmericaMenominee"] = "America/Menominee";
	Timezone["AmericaMetlakatla"] = "America/Metlakatla";
	Timezone["AmericaNewYork"] = "America/New_York";
	Timezone["AmericaNome"] = "America/Nome";
	Timezone["AmericaNorthDakotaBeulah"] = "America/North_Dakota/Beulah";
	Timezone["AmericaNorthDakotaCenter"] = "America/North_Dakota/Center";
	Timezone["AmericaNorthDakotaNewSalem"] = "America/North_Dakota/New_Salem";
	Timezone["AmericaPhoenix"] = "America/Phoenix";
	Timezone["AmericaPuertoRico"] = "America/Puerto_Rico";
	Timezone["AmericaSitka"] = "America/Sitka";
	Timezone["AmericaYakutat"] = "America/Yakutat";
	Timezone["PacificHonolulu"] = "Pacific/Honolulu";
	Timezone["AmericaEdmonton"] = "America/Edmonton";
	Timezone["AmericaHalifax"] = "America/Halifax";
	Timezone["AmericaRegina"] = "America/Regina";
	Timezone["AmericaToronto"] = "America/Toronto";
	Timezone["AmericaStJohns"] = "America/St_Johns";
	Timezone["AmericaVancouver"] = "America/Vancouver";
	Timezone["AmericaWhitehorse"] = "America/Whitehorse";
	Timezone["AmericaWinnipeg"] = "America/Winnipeg";
	Timezone["EuropeBerlin"] = "Europe/Berlin";
	Timezone["EuropeLondon"] = "Europe/London";
	return Timezone;
}(Timezone || {});
//#endregion
export { Timezone };

//# sourceMappingURL=timezone.js.map